module.exports = "images/doc-activity-add-empty-2.b4b6046098e305b39602e22c52065b37.png";